import React, { useState } from 'react'
import { useAuthContext } from '../../Hooks/useAuthContext'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'wc-toast'
import axios from 'axios'
import Navigation from '../../Component/Navigation/Navigation'

function ForgotPassword() {
  const [data, setData]         = useState([])
  const [disabled, setDisabled] = useState(false)
  const { user, dispatch }      = useAuthContext()
  const [btnState, setBtnState] = useState('Submit')
  const navigate                = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault()
    setDisabled(true)
    setBtnState('Processing...')
    console.log('in handle submit')
    console.log(process.env.REACT_APP_API_URL)
    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/user/forgot-password`,
      data,
      { headers: { 'Content-Type': 'application/json' } }
    ).then(response => {
      setDisabled(false)
      setBtnState('Submit')
      setData({ email: '' })
      toast.success('Check your email for the password reset link')
    }).catch(error => {
      setDisabled(false)
      console.log('in bad response')
      setBtnState('Submit')
      toast.error(error.response.data.error)
    })
  }

  return (
    <div className="auth-page">
      <Navigation />

      <div className="auth-split">

        {/* ── Left — image panel ─────────────────────────── */}
        <div className="auth-split__image">
          <div className="auth-split__image-body">
            <span className="auth-split__label">JFE Bank — Account Recovery</span>
            <h2 className="auth-split__title">
              Reset your <em>password</em>
            </h2>
            <p className="auth-split__sub">
              We'll send a secure link to your registered email address
              so you can regain access to your account.
            </p>
            <ul className="auth-trust">
              <li>Secure reset link via email</li>
              <li>Link expires in 30 minutes</li>
              <li>Contact support if you need help</li>
            </ul>
          </div>
        </div>

        {/* ── Right — form panel ─────────────────────────── */}
        <div className="auth-split__form">
          <div className="auth-card">
            <div className="auth-card__bar" />

            <div className="auth-card__head">
              <h2>Reset your password</h2>
              <p>Enter the email address associated with your account.</p>
            </div>

            <form className="auth-card__body" onSubmit={handleSubmit}>

              <div className="auth-info">
                A password reset link will be sent to your email. Please check
                your inbox and follow the instructions.
              </div>

              <div className="auth-field">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Enter your account email"
                  value={data?.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  required
                />
              </div>

              <button
                type="submit"
                className="auth-btn auth-btn--navy"
                disabled={disabled}
              >
                {btnState}
              </button>

              <div className="auth-divider" />

              <Link to="/login" style={{ textDecoration: 'none' }}>
                <button type="button" className="auth-btn auth-btn--outline">
                  ← Back to Login
                </button>
              </Link>

            </form>
          </div>
        </div>

      </div>
    </div>
  )
}

export default ForgotPassword